var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"articleContainRefs",class:`article-overall${_vm.receiveProps.blockInstanceId}`,style:(_vm.articleContainStyl)},[_c('TitleBar',{attrs:{"titleData":_vm.receiveProps}}),_c(_vm.componentTemp,{tag:"component",attrs:{"receiveProps":_vm.receiveProps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }